import React from 'react'
import { Modal, Button } from 'semantic-ui-react'
import { ImportConfirmation } from 'components/ImportConfirmation'

/**
 * @typedef ErrorRow
 * @property {number} rowNumber
 * @property {string} [invalidEmail]
 * @property {string} [invalidLanguage]
 * @property {string} [invalidDatetime]
 *
 * @typedef ImportDataValidationResult
 * @property {number} importRecordsAmount
 * @property {ErrorRow[]} errorRows
 *
 * @typedef FieldMappingData
 * @property {string} columnHeader
 * @property {string} simplesatField
 * @property {string} sampleData
 * @property {string} [field_type]
 *
 * @param {object} props
 * @param {ImportDataValidationResult} props.importDataValidationResult
 * @param {FieldMappingData[]} props.fieldMappingData
 * @param {function} props.onSampleFieldChange
 * @param {(e, prop) => void} props.onCancel
 * @param {(e, prop) => void} props.onNextStep
 */
export default function CustomerImportConfirmationModal({
  importDataValidationResult,
  fieldMappingData,
  onSampleFieldChange,
  onCancel,
  onNextStep,
}) {
  const formattedTotalImport =
    importDataValidationResult.importRecordsAmount.toLocaleString('en-US')
  const formattedTotalSkip = importDataValidationResult.errorRows.length.toLocaleString('en-US')

  return (
    <React.Fragment>
      <Modal.Header>Import review</Modal.Header>
      <Modal.Content>
        <ImportConfirmation
          formattedTotalImport={formattedTotalImport}
          formattedTotalSkip={formattedTotalSkip}
          singleErrorRows={importDataValidationResult.errorRows}
          isCustomerImport={true}
          fieldMappingData={fieldMappingData}
          onSampleFieldChange={onSampleFieldChange}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button className="primary" onClick={onNextStep}>
          Next step
        </Button>
      </Modal.Actions>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/CustomerImportConfirmationModal/index.js